<template>
    <rateio
        :servicos="obterServicos()"
        :permiteAtualizarRateio="$temAcessoView('SGTEC-UABS-ETP-02')"
    ></rateio>
</template>

<script>
import Rateio from '../../componentes/rateios/Rateio'
import ProjetosServicos from '../projetos/ProjetosServicos'

export default {
    components: {
        Rateio
    },

    methods: {
        obterServicos() {
            return ProjetosServicos
        }
    }
}
</script>
